/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
let registered = false;
/**
 * Polyfill for Safari
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/at
 */
export function at(n) {
    n = Math.trunc(n) || 0;
    if (n < 0) {
        n += this.length;
    }
    if (n < 0 || n >= this.length) {
        return undefined;
    }
    return this[n];
}
if (!registered) {
    registered = true;
    const TypedArray = Reflect.getPrototypeOf(Int8Array);
    for (const C of [Array, String, TypedArray]) {
        Object.defineProperty(C.prototype, 'at', {
            value: at,
            writable: true,
            enumerable: false,
            configurable: true,
        });
    }
}
